/* eslint-disable no-param-reassign */
import { push, replace } from 'connected-react-router';
import LayoutVersions from "./LayoutVersions.js";
function createSetLayoutId(component) {
  return ({
    value,
    isReplace = true
  }) => {
    const url = new URLSearchParams(window.location.search);
    const {
      dispatch
    } = component.props;
    if (value) {
      url.set('v', value);
    } else {
      url.delete('v');
    }
    const search = url.toString();
    dispatch(isReplace ? replace({
      search
    }) : push({
      search
    }));
  };
}
function createRevertLayout(component, key) {
  return () => {
    component.setState({
      [key]: null
    });
  };
}
function createGetCurrentLayoutId(component, layoutKey) {
  return value => {
    const layout = component.props[layoutKey];
    return layout?.layoutId;
  };
}
function createGetCurrentLayoutModel(component, key, propKey) {
  return value => {
    return component.state?.[key] || component.props[propKey];
  };
}

/**
 * Returns and optionally adds common methods to a React Component that manages a Layout. 
 * @param {React.Component} component this will be used to install default acess into props and state.
 * It uses the modifiedLayoutKey (or 'modifiedLayout' ) to access component.state to retreive the current
 * layout model that is being edited and propLayoutModelKey (or 'settings') to get the currently used/saved
 * layout model. If appendToComponent is not false the onLayout methods returned will be set on the component.
 * @param {*} opts 
 * @returns an object containg { onLayoutChange, onLayoutSave, onLayoutDelete, onLayoutRevert, onLayoutRename }
 */
function install(component, opts) {
  let {
    layoutKey,
    modifiedLayoutKey,
    propLayoutModelKey,
    setLayoutId,
    getCurrentLayoutId,
    revertLayout,
    getCurrentLayoutModel
  } = opts;
  layoutKey = layoutKey || 'layout';
  modifiedLayoutKey = modifiedLayoutKey || 'modifiedLayout';
  propLayoutModelKey = propLayoutModelKey || 'settings';
  setLayoutId = setLayoutId || createSetLayoutId(component);
  getCurrentLayoutId = getCurrentLayoutId || createGetCurrentLayoutId(component, layoutKey);
  revertLayout = revertLayout || createRevertLayout(component, modifiedLayoutKey);
  // saveCustomLayoutModel = saveCustomLayoutModel || createSaveCustomLayoutModel( component, clientTypeKey )
  getCurrentLayoutModel = getCurrentLayoutModel || createGetCurrentLayoutModel(component, modifiedLayoutKey, propLayoutModelKey);
  function onLayoutChange({
    value,
    isReplace
  }) {
    setLayoutId({
      value,
      isReplace
    });
  }
  function onLayoutRevert(evt) {
    revertLayout(evt);
  }
  function onLayoutDelete(evt) {
    return LayoutVersions.deleteLayout(evt);
  }
  function onLayoutRename(evt) {
    const layoutId = getCurrentLayoutId();
    return LayoutVersions.renameLayout(evt).then(r => {
      if (layoutId === evt.layoutVersion.value) {
        setLayoutId({
          value: r.value
        });
      }
      return r;
    });
  }
  function onLayoutSave(evt) {
    const layoutId = getCurrentLayoutId();
    const value = getCurrentLayoutModel();
    return LayoutVersions.saveLayout({
      value,
      ...evt
    }).then(r => {
      revertLayout();
      if (!evt.saveToCustomLayout && r.value !== layoutId) {
        setLayoutId({
          value: r.value
        });
      }
      return r;
    });
  }
  if (opts.appendToComponent !== false) {
    component.onLayoutChange = onLayoutChange;
    component.onLayoutSave = onLayoutSave;
    component.onLayoutDelete = onLayoutDelete;
    component.onLayoutRevert = onLayoutRevert;
    component.onLayoutRename = onLayoutRename;
  }
  return {
    onLayoutChange,
    onLayoutSave,
    onLayoutDelete,
    onLayoutRevert,
    onLayoutRename
  };
}
export default {
  install
};